// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"da3ad07b","359":"2dd22ec0","479":"69ad55ee","605":"daf74409","655":"6a5ce65a","754":"59e80323","842":"72d3e4d4"}[chunkId] + ".chunk.js";
};